import { defineStore } from 'pinia';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { useStoreSsPlayer } from '../softswiss/player';
import { strapi } from '../transport/strapi';
import type {
  INotificationWelcomeStrapiResponse,
  INotificationWelcome,
} from '~/types/notifications';

export const useStoreNotificationsWelcome = defineStore('notificationsWelcome', {
  state: () => ({
    notificationsWelcomeAll: [] as INotificationWelcome[],
    requestPromise: null as Promise<INotificationWelcomeStrapiResponse> | null,
  }),

  getters: {
    notificationsWelcome(): INotificationWelcome[] {
      const storeSsPlayer = useStoreSsPlayer();

      return this.notificationsWelcomeAll.filter((notif) =>
        notif.groupIds.split('\n').some((n) => storeSsPlayer.playerGroupIds.includes(n))
      );
    },
  },

  actions: {
    async loadNotifications() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'button',
          'icon',
          'bannerComplexNotification',
          'bannerComplexNotification.desktopAssetFront',
          'bannerComplexNotification.desktopAssetBack',
          'bannerComplexNotification.mobileAsset',
        ]);

        this.requestPromise = strapi()
          .get('notifications-welcomes', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        this.notificationsWelcomeAll = parseCollectionData(response.data);

        return true;
      } else {
        return false;
      }
    },
    clearStore() {
      this.$reset();
    },
  },
});
